import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailInvoiceDialogComponent } from './email-invoice.dialog';
import { InvoicesService } from 'src/app/services/invoices.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';

@Injectable({
  providedIn: 'root'
})
export class EmailInvoiceDialogService {

    public confirmEvidence: boolean = false;

    constructor(
        public dialog: MatDialog,
        public invoiceService: InvoicesService) {}

    public open(invoice: InvoiceInterface, pdfHash: string, callback: any) {
        return this.invoiceService.get(invoice.number).subscribe((result) => {
            let dialog = this.dialog.open(EmailInvoiceDialogComponent, {
                autoFocus: false,
                width: '650px',
                data: {
                    invoice,
                    pdfHash
                }
            });

            dialog.afterClosed().subscribe(job => {
                callback(job);
            })
        });
    }
}
